import { useContext } from "react";
import { useTranslations } from "use-intl";

import { FeaturePageSourceIndexContext } from "@/features/feature-page/feature-page-source-index-context";

export function FeaturePageCitations({
  sourceIds,
  placement = "inline",
}: {
  sourceIds?: string[];
  placement?: "footer" | "inline";
}) {
  const t = useTranslations("shared.sourceLinks");
  const sourceIndex = useContext(FeaturePageSourceIndexContext);
  if (!sourceIds?.length) return null;
  const orderedSourceIds =
    placement === "footer"
      ? [...sourceIds].sort(
          (left, right) =>
            (sourceIndex.get(left) ?? Number.POSITIVE_INFINITY) -
            (sourceIndex.get(right) ?? Number.POSITIVE_INFINITY),
        )
      : sourceIds;
  const links = orderedSourceIds.map((sourceId, index) => {
    const sourceNumber = sourceIndex.get(sourceId) ?? index + 1;
    return (
      <a
        key={sourceId}
        href={`#source-${sourceId}`}
        aria-label={`${t("sources")} ${sourceNumber}`}
        aria-describedby={`source-${sourceId}`}
        className="rounded-sm hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        [{sourceNumber}]
      </a>
    );
  });
  if (placement === "footer") {
    return (
      <div className="mt-auto flex justify-end gap-1 border-t border-border/60 pt-3 text-xs text-primary">
        {links}
      </div>
    );
  }
  return <sup className="ml-1 inline-flex gap-1 text-xs text-primary">{links}</sup>;
}
